import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Eye, Save } from "react-feather";
import { BsQrCode } from "react-icons/bs"; // Better QR code icon
import MenuPreview from "./MenuPreview";
import { jsPDF } from "jspdf";
import "./MenuFooter.css";

const MenuFooter = ({ menu, onSave }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);

  const generateQRCode = async (format) => {
    try {
      const qrUrl = `https://yourwebsite.com/menu/${menu.client_subdomain}`;
      const fileName = `${menu.name || "menu"}-qrcode.${format}`;

      if (format === "pdf") {
        // Crea il PDF
        const doc = new jsPDF();
        // Aggiungi il nome del ristorante
        doc.setFontSize(24);
        doc.text(menu.name || "Menu", 105, 30, { align: "center" });
        // Genera il QR Code come PNG data URL
        const qrImage = await import("qrcode").then((module) =>
          module.toDataURL(qrUrl, { width: 150, margin: 1 })
        );
        // Aggiungi il QR Code al PDF
        doc.addImage(qrImage, "PNG", 30, 50, 150, 150);
        // Salva il PDF
        doc.save(fileName);
      } else if (format === "png") {
        // Genera il QR Code come PNG data URL
        const qrDataUrl = await import("qrcode").then((module) =>
          module.toDataURL(qrUrl, { width: 150, margin: 1 })
        );
        // Crea un link temporaneo per il download
        const link = document.createElement("a");
        link.href = qrDataUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (format === "svg") {
        // Importa il modulo e gestisci sia la presenza che l'assenza della proprietà default
        const QRCodeModule = await import("qrcode").then((module) => module.default || module);
        const qrSvg = await QRCodeModule.toString(qrUrl, { type: "svg", width: 150, margin: 1 });
        // Crea un blob a partire dalla stringa SVG
        const blob = new Blob([qrSvg], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);
        // Crea un link temporaneo per il download
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
      
    } catch (error) {
      console.error("Error generating QR code:", error);
    }
  };

  const handleSave = async () => {
    try {
      await onSave(); // Salva il menu (in Dashboard.js)
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);
    }
    // Imposta il flag per far ricaricare Main.js (non la Dashboard)
    localStorage.setItem('forceReloadMain', Date.now().toString());
  };

  return (
    <>
      <div className="modern-footer">
        <div className="footer-buttons">
          <Button
            variant="light"
            className="footer-button preview-btn"
            onClick={() => setShowPreview(true)}
          >
            <Eye size={24} />
          </Button>

          <Button
            variant="primary"
            className="footer-button save-btn"
            onClick={handleSave}
          >
            <Save size={24} />
          </Button>

          <Button
            variant="light"
            className="footer-button qr-btn"
            onClick={() => setShowQrModal(true)}
          >
            <BsQrCode size={24} />
          </Button>
        </div>
      </div>

      {/* Replace Modal with direct MenuPreview */}
      {showPreview && (
        <div className="preview-overlay">
          <MenuPreview 
            menu={menu} 
            show={showPreview}
            onClose={() => setShowPreview(false)}
          />
        </div>
      )}

      {/* Keep existing QR Modal */}
      <Modal
        show={showQrModal}
        onHide={() => setShowQrModal(false)}
        centered
        className="qr-format-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Scegli formato QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="qr-format-options"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <Button
              variant="outline-primary"
              onClick={() => {
                generateQRCode("pdf");
                setShowQrModal(false);
              }}
            >
              Scarica come PDF
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => {
                generateQRCode("png");
                setShowQrModal(false);
              }}
            >
              Scarica come PNG
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => {
                generateQRCode("svg");
                setShowQrModal(false);
              }}
            >
              Scarica come SVG
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MenuFooter;
